































import {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Vue,
  Watch
} from "vue-property-decorator";
@Component({
  name: "RadioItem"
})
export default class RadioItem extends Vue {
  // 查询form
  @Prop({
    default: () => {
      return {};
    }
  })
  public formParam: any;
  @Prop({
    default: () => {
      return {};
    }
  })
  private config: any;
  private get itemData() {
    return this.formParam[this.config.value];
  }
  private set itemData(data) {
    const form: any = _.cloneDeep(this.formParam);
    form[this.config.value] = data;
    this.$emit("update:formParam", form);
  }
  private async selectChange(data: any) {
    if (this.config.change) {
      await this.$nextTick();
      this.config.change(data);
    }
  }
}
